import { z } from "zod";

const isoDateString = z.string().datetime({ offset: true });

export const changePlanOrPricePayloadSchema = z.object({
  customer_id: z.string().min(1),
  target_plan_id: z.string().min(1),
  new_amount: z.number().positive().optional(),
  effective_at: isoDateString.optional()
});

export type ChangePlanOrPricePayload = z.infer<typeof changePlanOrPricePayloadSchema>;
